module.exports = __webpack_public_path__ + "img/xjzz.6d4a6c4.png";